import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import { useLazyConfirmEmailQuery } from 'redux/Api/authApi/authApi';
import s from '../Login/Login.module.scss';
import logo from '../Login/img/logo.svg';
import { ReactComponent as IconCheck } from './img/iconDone.svg';

interface FormData {
  emailCode: string;
}

interface LocationState {
  phone?: string;
  surname?: string;
  name?: string;
  patronymic?: string;
  email?: string;
  password?: string;
  isTermsAccepted?: boolean;
  fromLogin?: boolean;
}

export const RegistrationStep3: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [verificationError, setVerificationError] = useState('');
  const [isCodeVerified, setIsCodeVerified] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const registrationData = location.state as LocationState;

  const [confirmEmail] = useLazyConfirmEmailQuery();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      emailCode: '',
    },
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const emailCode = watch('emailCode');

  useEffect(() => {
    if (!registrationData) {
      navigate('/login');
    }
  }, [registrationData, navigate]);

  const verifyEmailCode = async (code: string) => {
    if (!code || code.length !== 6) return false;

    try {
      const result = await confirmEmail({
        email: registrationData.email!,
        code: parseInt(code),
      }).unwrap();

      if (result.code_valid) {
        setIsCodeVerified(true);
        setVerificationError('');
        return true;
      } else {
        setVerificationError('Неверный код подтверждения');
        setIsCodeVerified(false);
        return false;
      }
    } catch (error) {
      setVerificationError('Ошибка при проверке кода');
      setIsCodeVerified(false);
      return false;
    }
  };

  // useEffect(() => {
  //   if (emailCode && emailCode.length === 6) {
  //     verifyEmailCode(emailCode);
  //   } else {
  //     setIsCodeVerified(false);
  //     setVerificationError('');
  //   }
  // }, [emailCode]);

  const onSubmit = async () => {
    if (!emailCode || emailCode.length !== 6) {
      setVerificationError('Введите код из 6 цифр');
      return;
    }

    setLoading(true);
    setVerificationError('');

    const isValid = await verifyEmailCode(emailCode);

    if (isValid) {
      setTimeout(() => {
        navigate('/registration/step4', {
          state: {
            ...registrationData,
            emailVerified: true,
          },
        });
        setLoading(false);
      }, 500);
    } else {
      setLoading(false);
    }
  };

  const handleBackToStep2 = () => {
    navigate('/registration/step2', { state: registrationData });
  };

  return (
    <div className={s.enter}>
      <div className={s.inner}>
        <div className={s.logo}>
          <img src={logo} alt='Скилла' />
        </div>

        <h1 className={s.titleStepRegister}>Двухфакторная авторизация</h1>
        <div className={s.stepper}>
          <div className={s.stepperItem}></div>
          <div className={s.stepperItem}></div>
          <div className={s.stepperItem}></div>
        </div>

        <div className={s.stepperText}>
          <div className={s.stepperTextItem}>
            <IconCheck />
            <span>Пароль обеспечит защиту твоих средств</span>
          </div>
          <div className={s.stepperTextItem}>
            <IconCheck />
            <span>Восстановить пароль можно по Email</span>
          </div>
        </div>

        <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
          <div className={s.inputGroup}>
            <label>Email</label>
            <input
              type='email'
              value={registrationData?.email || ''}
              disabled
              className={classNames(s.input, s.inputDisabled)}
            />
          </div>

          <div className={s.inputGroup}>
            <label>Код подтверждения</label>
            <input
              type='text'
              placeholder='123456'
              maxLength={6}
              className={classNames(
                s.input,
                (errors.emailCode || verificationError) && s.input_error,
                isCodeVerified && s.inputSuccess,
              )}
              {...register('emailCode', {
                required: 'Поле обязательно для заполнения',
                pattern: {
                  value: /^\d{6}$/,
                  message: 'Код должен содержать 6 цифр',
                },
                onChange: () => {
                  if (verificationError) {
                    setVerificationError('');
                    setIsCodeVerified(false);
                  }
                },
              })}
            />
            {errors.emailCode && (
              <div className={s.errorMessage}>{errors.emailCode.message}</div>
            )}
            {verificationError && (
              <div className={s.errorMessage}>{verificationError}</div>
            )}
            {isCodeVerified && <div className={s.successMessage}>Email подтвержден!</div>}
          </div>

          <button type='submit' disabled={loading} className={s.submitButton}>
            Продолжить
          </button>

          <button
            type='button'
            className={s.registerButton}
            onClick={() => navigate('/login')}>
            Начать сначала
          </button>
        </form>

        <div className={s.footer}>
          <span>© {new Date().getFullYear()} go.skilla.ru</span>
        </div>
      </div>
    </div>
  );
};
